import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import UserUtils from 'utils/user-utils';
import getParkingType from '../utils/parking-type';
export default function trackCheckoutErrorMessageDisplayed({ isMonthly, isAirport, isEventPackage, isEvent, errorMessage, pageSection, userStatus, }) {
    try {
        const parkingType = getParkingType({
            isMonthly,
            isAirport,
            isEvent,
            isEventPackage,
        });
        const properties = {
            error_message: errorMessage,
            parking_type: parkingType,
            user_logged_in: userStatus === UserUtils.AUTH_STATE.USER,
            section: pageSection,
            location: 'Checkout',
        };
        SegmentUtils.track({
            event: 'Checkout Error Message Displayed',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - trackCheckoutErrorMessageDisplayed',
        });
    }
}
